module.exports = __webpack_public_path__ + "static/box8-872e2a74321e9d18751529f182048724.webp";